var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoorsWindows6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#F3F4F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2062 8.66797V19.3346H15.1718V8.66797H10.2062ZM12.4131 9.33464V12.0013H10.758V9.33464H12.4131ZM14.62 15.3346H12.9649V12.668H14.62V15.3346ZM12.4131 15.3346H10.758V12.668H12.4131V15.3346ZM10.758 16.0013H12.4131V18.668H10.758V16.0013ZM12.9649 18.668V16.0013H14.62V18.668H12.9649ZM14.62 12.0013H12.9649V9.33464H14.62V12.0013Z",
    fill: "#6B7280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2062 24.6667H15.1718V20H10.2062V24.6667ZM10.758 20.6667H14.62V24H10.758V20.6667Z",
    fill: "#6B7280"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8281 8.66797V19.3346H21.7936V8.66797H16.8281ZM19.035 9.33464V12.0013H17.3798V9.33464H19.035ZM21.2419 15.3346H19.5867V12.668H21.2419V15.3346ZM19.035 15.3346H17.3798V12.668H19.035V15.3346ZM17.3798 16.0013H19.035V18.668H17.3798V16.0013ZM19.5867 18.668V16.0013H21.2419V18.668H19.5867ZM21.2419 12.0013H19.5867V9.33464H21.2419V12.0013Z",
    fill: "#6B7280"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8281 24.6667H21.7936V20H16.8281V24.6667ZM17.3798 20.6667H21.2419V24H17.3798V20.6667Z",
    fill: "#6B7280"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6V26H24V6H8ZM9.65517 25.3333V8H15.7241V25.3333H9.65517ZM16.2759 25.3333V8H22.3448V25.3333H16.2759ZM23.4483 25.3333H22.8966V7.33333H9.10345V25.3333H8.55172V6.66667H23.4483V25.3333Z",
    fill: "#6B7280"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2887 21.7638L17.7369 22.4305C17.6294 22.5605 17.6294 22.7705 17.7369 22.9005C17.7921 22.9672 17.8611 23.0005 17.9328 23.0005C18.0045 23.0005 18.0735 22.9672 18.1286 22.9038L18.6804 22.2371C18.788 22.1071 18.788 21.8972 18.6804 21.7672C18.5728 21.6371 18.3963 21.6338 18.2887 21.7638Z",
    fill: "#6B7280"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3111 21.3333C19.3111 21.5175 19.1876 21.6667 19.0353 21.6667C18.8829 21.6667 18.7594 21.5174 18.7594 21.3333C18.7594 21.1492 18.8829 21 19.0353 21C19.1876 21 19.3111 21.1492 19.3111 21.3333Z",
    fill: "#6B7280"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.208 21.3333C18.208 21.5175 18.0845 21.6667 17.9321 21.6667C17.7797 21.6667 17.6562 21.5174 17.6562 21.3333C17.6562 21.1492 17.7797 21 17.9321 21C18.0845 21 18.208 21.1492 18.208 21.3333Z",
    fill: "#6B7280"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6668 21.7638L11.1151 22.4305C11.0075 22.5605 11.0075 22.7705 11.1151 22.9005C11.1702 22.9672 11.2392 23.0005 11.3109 23.0005C11.3826 23.0005 11.4516 22.9672 11.5068 22.9038L12.0585 22.2371C12.1661 22.1071 12.1661 21.8972 12.0585 21.7672C11.9509 21.6371 11.7744 21.6338 11.6668 21.7638Z",
    fill: "#6B7280"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6892 21.3333C12.6892 21.5175 12.5657 21.6667 12.4134 21.6667C12.261 21.6667 12.1375 21.5174 12.1375 21.3333C12.1375 21.1492 12.261 21 12.4134 21C12.5657 21 12.6892 21.1492 12.6892 21.3333Z",
    fill: "#6B7280"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5861 21.3333C11.5861 21.5175 11.4626 21.6667 11.3102 21.6667C11.1579 21.6667 11.0344 21.5174 11.0344 21.3333C11.0344 21.1492 11.1579 21 11.3102 21C11.4626 21 11.5861 21.1492 11.5861 21.3333Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorsWindows6);
export default __webpack_public_path__ + "static/media/Doors  Windows  6.9929bacb802ee5c5628ab9270a68c832.svg";
export { ForwardRef as ReactComponent };